<template>
  <div class="name module">
    <h2 class="display">{{service.name}}</h2>
    <span>{{service.alternative_name}}</span>
    <div class="more">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "Name",
  components: {},
  props: [ 'service' ],
  data() {
    return {}
  },
  computed: {
    service_name() {
      return this.service.alternative_name || this.service.name
    }
  }
};
</script>

<style scoped lang="scss">
.name {
  display: grid;
  grid-gap: 0;
  // No color set here — inherits from parent context (white in Service header, etc.)

  .more {
    display: grid;
    grid-gap: 0.5rem;
  }
}

// When used on a light/print background (PDF.vue adds .print to the component)
.name.print {
  font-size: 0.7rem;
  grid-gap: 0;
  color: $primary !important;

  * {
    color: $primary !important;
  }

  .more {
    grid-gap: 0;
  }

  .display {
    font-size: 1rem;
    font-weight: bold;
  }
}
</style>